import { useEffect, useState } from "react";
import {
  Form,
  Button,
  FloatingLabel,
  Col,
  Container,
  Row,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useLocalizedRoutes } from "../../../hooks/useLocalizedRoutes";
import { SaldoStep } from "./SaldoStep";
import Feedback from "react-bootstrap/esm/Feedback";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import axiosApi from "../../../axios/axios-api";
import { ValidateToken } from "../../../helpers/validateToken";
import { startLogout } from "../../../store/auth";
import coinIcon from "../../../assets/images/coin-icon.svg";
import file_download from "../../../assets/images/download-pdf-icon.svg";
import { toast } from "react-toastify";
import { LogoPetroprix } from "../../ui/LogoPetroprix";

const URL_POST_AGREGAR_SALDO = "flotas/solicitudRecarga/";

export const AgregarSaldoScreen = () => {
  const [validated, setValidated] = useState(false);
  // const { flotaActiva } = useSelector((state) => state.auth);
  const [file, setFile] = useState("");
  const [fileName, setFileName] = useState("");
  const [validatingFile, setValidatingFile] = useState(false);
  const [saldoFuturo, setSaldoFuturo] = useState("-");
  const [cantidadSaldo, setCantidadSaldo] = useState(1);
  const [observation, setObservation] = useState("");
  const [savingData, setSavingData] = useState(false);

  const { token, idClienteFlota } = useSelector((state) => state.auth);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { getPath } = useLocalizedRoutes();

  const [saldos, setSaldos] = useState({
    saldoTotal: "-",
    saldoRestante: "-",
    saldoUsado: "-",
  });

  const [formErrors, setFormErrors] = useState({
    importe: false,
    file: false,
  });

  useEffect(() => {
    const current = parseFloat(saldos?.saldoRestante) || 0;
    const sum = current + parseInt(cantidadSaldo);
    setSaldoFuturo(sum);
  }, [cantidadSaldo, saldos]);

  useEffect(() => {}, [saldos]);

  const fetchSaldosFlota = async (id) => {
    try {
      if (process.env.REACT_APP_URL_API && ValidateToken()) {
        const response = await axiosApi.get(`flotas/saldos/${id}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        });
        if (response?.data?.code === 200) {
          let data = response.data.data;
          setSaldos({
            saldoTotal: data.saldo_inicio_mensual,
            saldoRestante: data.saldo_disponible,
            saldoUsado: data.saldo_usado,
          });
        }
      } else {
        dispatch(startLogout("expired"));
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (token) {
      fetchSaldosFlota(idClienteFlota);
    }
  }, [idClienteFlota]);

  const submitFormData = async (e) => {
    e.preventDefault();
    setValidated(false);
    setSavingData(true);

    let dataValid = {
      importe: false,
      file: false,
    };

    if (
      cantidadSaldo === "" ||
      cantidadSaldo < 1 ||
      isNaN(cantidadSaldo) ||
      cantidadSaldo > 999999
    ) {
      setFormErrors({ ...formErrors, importe: true });
    } else {
      setFormErrors({ ...formErrors, importe: false });
    }

    if (file.name === "") {
      setFormErrors({ ...formErrors, file: true });
    } else {
      setFormErrors({ ...formErrors, file: false });
    }

    if (formErrors.importe || formErrors.file) {
      setSavingData(false);
      setValidated(true);
      return;
    }

    try {
      const data = new FormData();
      data.append("amount", parseInt(cantidadSaldo));
      data.append("file", file);

      if (observation && observation.length > 0) {
        data.append("observation", observation);
      }

      if (process.env.REACT_APP_URL_API && ValidateToken()) {
        const response = await axiosApi.post(
          URL_POST_AGREGAR_SALDO + idClienteFlota,
          data,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + token,
            },
          }
        );
        if (response?.data?.code === 200) {
          toast(response?.data?.message, {
            icon: <LogoPetroprix />,
          });
          navigate(getPath('fleetsMyFleets'));
        } else {
          toast(response?.data?.message, {
            icon: <LogoPetroprix />,
          });
        }
        setSavingData(false);
      } else {
        dispatch(startLogout("expired"));
        setSavingData(false);
      }
    } catch (error) {
      console.error(error);
      setSavingData(false);
    }
  };

  return (
    <>
      <Container className="content-body mt-4 px-4">
        <Container>
          <Row className="page-header pb-4">
            <Col sm={12} lg={{ span: 5, order: 1 }}>
              <h1>{t("flotas.agregar-saldo.header.h1")}</h1>
            </Col>
          </Row>
        </Container>
        <Container className="py-1">
          <Row className="content-section bg-white radius-8 pb-4 pt-4">
            <Col
              xs={12}
              lg={{ span: 4 }}
              className="text-center"
              style={{ margin: "0 auto" }}
            >
              <img
                src={coinIcon}
                alt="Coin icon"
                className="mb-4"
                width={120}
              />
              <p className="">
                {t("flotas.agregar-saldo.info-1")},{" "}
                {t("flotas.agregar-saldo.info-2")}
              </p>
              <p className=" mb-4">{t("flotas.agregar-saldo.info-3")}</p>
            </Col>
            <Col xs={12} lg={{ span: 6 }} style={{ margin: "0 auto" }}>
              <Form
                className="flotas-agregar-saldo-form mt-2"
                autoComplete="off"
                onSubmit={(e) => submitFormData(e)}
                noValidate
                validated={validated}
              >
                <Row>
                  {/* Top cards: saldo actual y saldo futuro */}
                  <Row className="mb-3">
                    <div className="col-md-6 mb-2">
                      <div className="card h-100">
                        <div className="card-body">
                          <h6 className="card-title mt-2 mb-0">
                            {t("flotas.agregar-saldo.form.saldo-actual")}
                          </h6>
                          <p
                            className="fw-bold"
                            style={{ fontSize: "1.25rem" }}
                          >
                            {saldos?.saldoRestante ?? "-"}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 mb-2">
                      <div className="card h-100">
                        <div className="card-body">
                          <h6 className="card-title mt-2 mb-0">
                            {t("flotas.agregar-saldo.form.saldo-futuro")}
                          </h6>
                          <p
                            id="flotas-agregar-saldo-futuro"
                            className="fw-bold text-primary"
                            style={{ fontSize: "1.5rem" }}
                          >
                            {saldoFuturo}
                          </p>
                        </div>
                      </div>
                    </div>
                  </Row>
                  <FloatingLabel
                    label={t("flotas.agregar-saldo.form.importe")}
                    className="mb-3"
                    style={{ paddingRight: "2.3em" }}
                  >
                    <Form.Control
                      type="number"
                      step="1"
                      min="1"
                      max="999999"
                      value={cantidadSaldo}
                      onChange={(e) => {
                        const value = e.target.value;
                        //Si no es un número, es decimal o es menor que 1, no actualizar
                        if (
                          isNaN(value) ||
                          value.includes(".") ||
                          value.includes(",") ||
                          value < 1 ||
                          value > 999999
                        ) {
                          return;
                        }
                        setCantidadSaldo(value);
                      }}
                      pattern="^[1-9][0-9]{0,5}$"
                      id="flotas-agregar-saldo-importe"
                    />
                    <Feedback type="invalid">
                      {t("flotas.agregar-saldo.form.importe.invalid")}
                    </Feedback>
                  </FloatingLabel>
                  {/* <Row>
            <div className="flotas-registro-buttons mt-5">
              <Button
                variant="outline-primary"
                size="lg"
                name="cantidad"
                onClick={handleGoBack}
              >
                {t("flotas.registro-flota.btn-back")}
              </Button>
              <Button variant="primary" size="lg" type="submit">
                {t("flotas.registro-flota.btn-next")}
              </Button>
            </div>
          </Row> */}
                  <Row style={{ paddingLeft: "1em" }}>
                    <Button
                      variant="outline-file"
                      id="nombre-fichero"
                      onClick={() => {}}
                      className={"btn-outline-file mt-2 m-2 mb-2"}
                      style={{ width: "280px" }}
                      disabled={true}
                    >
                      {fileName}
                    </Button>
                    <label
                      htmlFor="upload-document"
                      variant="outline-primary-file"
                      className="m-2 py-2 btn btn-outline-primary-file btn-sm"
                      style={{ width: "280px" }}
                    >
                      <img src={file_download} alt="" />{" "}
                      {t("flotas.table.seleccionar-archivo")} (PDF, JPG, PNG)
                    </label>
                    <input
                      type="file"
                      name="document"
                      id="upload-document"
                      accept="application/pdf,image/jpeg,image/png"
                      onChange={(e) => {
                        setFile(e.target.files[0]);
                        setFileName(e.target.files[0]?.name || "");
                      }}
                    />
                  </Row>
                </Row>
                <Row>
                  <Col xs={12} className="flotas-registro-buttons mt-3">
                    <Button
                      variant={"outline-primary"}
                      className="flotas-btn-add"
                      disabled={
                        savingData || fileName.length === 0 ? true : false
                      }
                      onClick={submitFormData}
                      style={
                        validatingFile
                          ? {
                              pointerEvents: "none",
                              backgroundColor: "white",
                            }
                          : {}
                      }
                    >
                      {/* {validatingFile ? (
              <>
                <MiniLoader size="xs" />
                <span style={{ color: "#db0b27" }} className="p-1">
                  {t("flotas.registro-flota.informacion.btn-next.validating")}
                </span>
              </>
            ) : ( */}
                      {t("flotas.agregar-saldo.form.btn-enviar")}
                      {/* )} */}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </Container>
      </Container>
    </>
  );
};
